import React from "react";
import { ReactLenis } from "lenis/react";

// Awwwards-style momentum smooth scrolling. Disabled automatically for users
// who prefer reduced motion.
export const SmoothScroll = ({ children }) => {
  const prefersReduced =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReduced) return <>{children}</>;

  return (
    <ReactLenis root options={{ duration: 1.1, smoothWheel: true, lerp: 0.09 }}>
      {children}
    </ReactLenis>
  );
};

export default SmoothScroll;
